import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import ViewsStepA from '@/views/step-a/ViewsStepA'
import ViewsStepB from '@/views/step-b/ViewsStepB'
import ViewsStepC from '@/views/step-c/ViewsStepC'
import ViewsConfirmation from '@/views/confirmation/ViewsConfirmation'
import ViewsPayment from '@/views/payment/ViewsPayment'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'stepA',
    component: ViewsStepA
  },
  {
    path: '/step-b',
    name: 'stepB',
    component: ViewsStepB
  },
  {
    path: '/step-c',
    name: 'stepC',
    component: ViewsStepC
  },
  {
    path: '/confirmation',
    name: 'confirmation',
    component: ViewsConfirmation
  },
  {
    path: '/payment',
    name: 'payment',
    component: ViewsPayment
  }
]

export const nextRouteMap = {}

const router = new VueRouter({
  mode: 'abstract',
  base: window.self === window.top ? process.env.BASE_URL : process.env.BASE_URL || `${window.location.pathname}/`, // use current location as base only if widget inside iframe
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// if there is no formData redirect user to first step
router.beforeEach((to, from, next) => {
  if (Object.keys(store.getters['formData/formData']).length === 0 && to.name !== 'stepA') {
    next({
      name: 'stepA',
      query: to.query
    })
  }
  next()
})
export default router
